import { mapState } from 'vuex';
import { STATUS_CODES } from '@/constants';

const getCustomList = state => state.entitySources.entitySources
  .filter(source => source.type.startsWith('custom.list'));

export default {
  name: 'entityCustomSourceList',
  computed: {
    ...mapState({
      customListState: state => getCustomList(state).sort((a, b) => {
        const A = a.name.toUpperCase();
        const B = b.name.toUpperCase();

        if (A === B) {
          return 0;
        }

        return A < B ? -1 : 1;
      }),
    }),
    customlist() {
      return this.customListState.map(item => item);
    },
  },
  watch: {
    customListState(newChips) {
      this.newChips = newChips.map(() => '');
    },
  },
  data: function() {
    return {
      // A new customList Name
      newListName: '',
      showNewListFlag: false,
      newChips: [],
    };
  },
  mounted() {
    this.newChips = getCustomList(this.$store.state).map(() => '');
    this.$store.dispatch('entities/getEntitiesList', [
      { q: '', limit: 1000, offset: 0 },
      this.offset === 0,
    ]);
  },
  methods: {
    onNewList() {
      this.showNewListFlag = !this.showNewListFlag;
      this.nextTick(() => {
        document.querySelector('#new-tags-input').children[0].focus();
      });
    },

    onDeleteItem(listIndex, itemIndex) {
      this.customlist[listIndex].items.splice(itemIndex, 1);
      this.updateList(this.customlist[listIndex]);
    },

    onAddItem(listIndex) {
      const regex = new RegExp(/[^a-zA-Z0-9_]/);
      if (regex.test(this.newChips[listIndex])) {
        this.$aiq.notify.error(this.$t('iq_tools_tab.entities.entity_sources.custom_lists.no_special_characters_or_spaces'));
        return;
      }
      const listItem = this.customlist[listIndex];
      if (this.newChips[listIndex]
          && !(listItem.items.includes(this.newChips[listIndex]))) {
        listItem.items.push(this.newChips[listIndex]);
        this.newChips[listIndex] = '';
        this.updateList(listItem);
      } else if (listItem.items.includes(this.newChips[listIndex])) {
        this.$aiq.notify.info(
          `${this.newChips[listIndex]} is already in the list.`,
        );
      }
    },

    updateList(item) {
      return this.$store.dispatch('entitySources/updateEntitysource', {
        id: item.id,
        item,
      }).then(() => this.$aiq.notify.success(`${item.name} has been updated.`)).catch(() => this.$aiq.notify.error(`${item.name} is not updated.`));
    },

    createList() {
      if (!this.newListName) {
        return;
      }

      if (this.customlist.find(l => l.name === this.newListName)) {
        this.$aiq.notify.info(
          `${this.newListName} is already being used.`,
        );
        return;
      }

      return this.$store.dispatch('entitySources/createEntitysource', {
        type: 'custom.list',
        name: this.newListName,
      }).then(() => {
        this.$aiq.notify.success(`${this.newListName} has been saved.`);
        this.showNewListFlag = false;
        this.newListName = '';
      }).catch(() => this.$aiq.notify.error(`${this.newEntityName} is not saved.`));
    },
    async deleteEntityList(item) {
      const content = `Are you sure you want to delete <b>@${item.name}</b>?`;
      const confirm = await this.$aiq.confirm(item.name, content);
      if (confirm) {
        try {
          await this.$store.dispatch('entitySources/deleteEntitysource', item.id);
          this.$aiq.notify.success(`${item.name} has been deleted.`);
        } catch (error) {
          if (error.response.status === STATUS_CODES.CONFLICT) {
            const entities = JSON.parse(error.response.data.message);
            const conflict_content = `This Entity is nested in the following<br>
            <ul class="conflict-list">
              ${entities.map(e => `<li>${e.name}</li>`).join('')}
            </ul><br>
            You must remove conflicts before you can proceed.`;
            this.$aiq.confirm(item.name, conflict_content, {
              showCancelButton: false,
              customClass: 'conflict-dialog',
            });
          } else {
            this.$aiq.notify.error(`${name} deletion failed.`);
          }
        }
      }
      else {
        this.$aiq.closeConfirm();
      }
    },
  },
};
